import { render, staticRenderFns } from "./FormActions.vue?vue&type=template&id=24608896&scoped=true"
import script from "./FormActions.vue?vue&type=script&lang=js"
export * from "./FormActions.vue?vue&type=script&lang=js"
import style0 from "./FormActions.vue?vue&type=style&index=0&id=24608896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24608896",
  null
  
)

export default component.exports